var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCrownBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.083 5.417L5.625 8.75L10 3.333L14.375 8.75L17.917 5.417L16.667 15.417H3.333L2.083 5.417ZM3.75 16.667H16.25V18.333H3.75V16.667Z",
    fill: "#1B4B86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrownBlue);
export default __webpack_public_path__ + "static/media/icon_crown_blue.0f8dfd7c0812b684c7fd43f52d43b469.svg";
export { ForwardRef as ReactComponent };